"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DraggingState = void 0;
const rc_js_util_1 = require("rc-js-util");
const e_pointer_event_type_1 = require("../internal-events/e-pointer-event-type");
class DraggingState {
    constructor(startEvent, options, providers, sharedState) {
        this.startEvent = startEvent;
        this.options = options;
        this.providers = providers;
        this.sharedState = sharedState;
        // the starting event is one that needs to be handled straight away
        this.handlePointerEvent(e_pointer_event_type_1.EPointerEventType.Move, this.startEvent);
    }
    handleMouseEvent() {
        return null;
    }
    handlePointerEvent(eventType, chartEvent) {
        switch (eventType) {
            case e_pointer_event_type_1.EPointerEventType.Out:
            case e_pointer_event_type_1.EPointerEventType.Up:
                if (this.startEvent.$event.pointerId === chartEvent.$event.pointerId) {
                    this.providers.callbacks.onDragEnd(chartEvent);
                    return this.providers.stateFactories.getIdleState(null, this.options, this.providers, this.sharedState);
                }
                else {
                    return null;
                }
            case e_pointer_event_type_1.EPointerEventType.Down:
                {
                    return null;
                }
            case e_pointer_event_type_1.EPointerEventType.Move:
                {
                    if (this.startEvent.$event.pointerId === chartEvent.$event.pointerId) {
                        this.providers.callbacks.onDrag(chartEvent);
                    }
                    return null;
                }
        }
        return rc_js_util_1._Production.assertValueIsNever(eventType);
    }
}
exports.DraggingState = DraggingState;
//# sourceMappingURL=dragging-state.js.map